<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Granação (100%)</mat-label>
                                <input matInput id="txtGranacao_100" #txtGranacao_100 maxlength="3"
                                    formControlName="Granacao_100" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtGranacao_100.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Granacao_100)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Granação (75%)</mat-label>
                                <input matInput id="txtGranacao_75" #txtGranacao_75 maxlength="3"
                                    formControlName="Granacao_75" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtGranacao_75.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Granacao_75)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Granação (50%)</mat-label>
                                <input matInput id="txtGranacao_50" #txtGranacao_50 maxlength="3"
                                    formControlName="Granacao_50" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtGranacao_50.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Granacao_50)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Granação (25%)</mat-label>
                                <input matInput id="txtGranacao_25" #txtGranacao_25 maxlength="3"
                                    formControlName="Granacao_25" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtGranacao_25.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Granacao_25)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Granação (0%)</mat-label>
                                <input matInput id="txtGranacao_0" #txtGranacao_0 maxlength="3"
                                    formControlName="Granacao_0" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtGranacao_0.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Granacao_0)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Total Espigas Granação
                                </mat-label>
                                <input matInput id="txtTotal_espigas_granacao" #txtTotal_espigas_granacao maxlength="3"
                                    formControlName="Total_espigas_granacao" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    [readonly]="readOnlyGranacao" [class.InputBlockColor]="readOnlyGranacao">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readOnlyGranacao"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readOnlyGranacao"></i>
                                <!-- class="InputBlockColor" readonly
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconDisableField}}"></i> -->
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTotal_espigas_granacao.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Total_espigas_granacao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Granação Média (%)
                                </mat-label>
                                <input matInput id="txtGranacao_media" #txtGranacao_media maxlength="10"
                                    formControlName="Granacao_media" currencyMask [readonly]="readOnlyGranacao"
                                    [class.InputBlockColor]="readOnlyGranacao">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readOnlyGranacao"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readOnlyGranacao"></i>
                                <!-- readonly class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i> -->
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGranacao_media.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Granacao_media)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">

                        <div class="col-lg col-md col-xs col-sm col-xl text-right">
                            <button mat-flat-button color="primary" class="btnSizeLarge" matTooltip="Adicionar"
                                (click)="addItem()">
                                <i class="fa fa-plus fa-1x btnIcon"></i> Adicionar Lote
                            </button>
                            <button mat-flat-button color="primary" class="btnSizeLarge" matTooltip="Remover"
                                (click)="removeItem()" [disabled]="disabledBtnRemove">
                                <i class="fa fa-minus fa-1x btnIcon"></i> Remover Lote
                            </button>
                        </div>
                    </div>


                    <ng-template #viewContainerRef></ng-template>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inicio Seleção Data
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSelecaoInicio" #txtSelecaoInicio maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="inicio_selecao_data" (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtSelecaoInicio.value.length}} / 10</mat-hint>
                                <mat-error>Não pode ser anterior a data fim de secagem
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inicio Seleção Hora
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSelecaoInicioHora" #txtSelecaoInicioHora maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="inicio_selecao_hora" mask="Hh:m0"
                                    (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtSelecaoInicioHora.value.length}} / 5</mat-hint>
                                <mat-error>Não pode ser anterior a data fim de secagem
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso de Espigas Atipicas (kg)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtEspigasAtipicas" #txtEspigasAtipicas maxlength="10"
                                    formControlName="peso_espigas_atipicas_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    (blur)="makeCalc($event)">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso de Espigas Fora do Padrão (kg)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtForaPadrao" #txtForaPadrao maxlength="10"
                                    formControlName="peso_espigas_fora_do_padrao_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Fim Seleção Data
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSelecaoFim" #txtSelecaoFim maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000" formControlName="fim_selecao_data"
                                    (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtSelecaoFim.value.length}} / 10</mat-hint>
                                <mat-error>Não pode ser anterior a data inicio de seleçao
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Fim Seleção Hora
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSelecaoFimHora" #txtSelecaoFimHora maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="fim_selecao_hora" mask="Hh:m0"
                                    (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtSelecaoFimHora.value.length}} / 5</mat-hint>
                                <mat-error>Não pode ser anterior a data inicio de seleçao
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espigas Atipicas (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtAtipicasPcr" #txtAtipicasPcr maxlength="5"
                                    formControlName="espigas_atipicas_prc" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2, suffix: '%' }" readonly
                                    class="InputBlockColor">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Presença de outras sementes?
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <mat-select formControlName="presenca_outras_sementes" disableOptionCentering>
                                    <mat-option *ngFor="let item of listOutrasSementes" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de parada hora seleção
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtTempoParada" #txtTempoParada maxlength="5"
                                    formControlName="tempo_parada_selecao_hora" mask="Hh:m0"
                                    (blur)="validDates($event)">

                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtTempoParada.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_parada_selecao_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Motivo de parada</mat-label>
                                <textarea matInput id="txtMotivoParada" #txtMotivoParada maxlength="255"
                                    formControlName="motivo_parada_resselecao"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtMotivoParada.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.motivo_parada_resselecao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Caixa pós-mesa
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtCaixaPosMesa" #txtCaixaPosMesa maxlength="5"
                                    formControlName="caixa_pos_mesa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="changeCaixaPosMesa($event)">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Descarte mesa de seleção (kg)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtDescarteMesaSelecao" #txtDescarteMesaSelecao maxlength="10"
                                    formControlName="peso_descarte_mesa_selecao_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Desgrana mesa de seleção (kg)</mat-label>
                                <input matInput id="txtDesgramaMesa" #txtDesgramaMesa maxlength="10"
                                    formControlName="desgrana_mesa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.desgrana_mesa )}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso pós-mesa
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoPosMesa" #txtPesoPosMesa maxlength="10"
                                    formControlName="peso_pos_mesa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resseleção?
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <mat-select formControlName="resselecao" disableOptionCentering>
                                    <mat-option *ngFor="let item of listResselecao" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                    </div>



                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>